export default "* Hvad er en glød?\n* Hvilke farver har gløder i et bål?\n* Hvad kan du selv bedst lide ved at lave bål?\n";